import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "circle pass"
}
const _hoisted_2 = {
  key: 1,
  class: "circle ready"
}

import { ref, reactive, toRefs, computed } from "vue";
import { API } from "@/api/setting";
import useLoading from "@/hooks/loading";
import { downloadFile } from "@/utils/util";
//   import List from './list.vue';
import { useIntervalFn } from '@vueuse/core'
interface TabItem {
  key: string;
  title: string;
  avatar?: string;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'file-box',
  setup(__props) {

const { loading, setLoading } = useLoading(true);
const renderList = ref([]);
const scroll = {
  y: 200,
  x: 500,
};
async function fetchSourceData() {
  setLoading(true);
  try {
    const { data } = await API.queryDownloadFile({});
    console.log(data);
    renderList.value = data;
  } catch (err) {
    // you can report use errorHandler or other
  } finally {
    setLoading(false);
  }
}
const download = (url) => {
  downloadFile(url);
};
fetchSourceData();
const { pause, resume, isActive } = useIntervalFn(() => {
  fetchSourceData();
}, 5000)

return (_ctx: any,_cache: any) => {
  const _component_a_table_column = _resolveComponent("a-table-column")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, {
    title: "文件管理助手",
    bodyStyle: {padding:0}
  }, {
    extra: _withCtx(() => _cache[0] || (_cache[0] = [
      _createElementVNode("span", { style: {"color":"#999"} }, "仅显示近1天的下载任务　", -1)
    ])),
    default: _withCtx(() => [
      _createVNode(_component_a_table, {
        "row-key": "id",
        style: {"width":"520px"},
        loading: _unref(loading),
        pagination: false,
        data: renderList.value,
        scroll: scroll,
        size: "small"
      }, {
        columns: _withCtx(() => [
          _createVNode(_component_a_table_column, {
            title: "文件名",
            "data-index": "taskName",
            tooltip: "",
            ellipsis: ""
          }),
          _createVNode(_component_a_table_column, {
            title: "开始时间",
            "data-index": "startTime",
            width: 180
          }),
          _createVNode(_component_a_table_column, {
            title: "状态",
            "data-index": "state",
            width: 90
          }, {
            cell: _withCtx(({ record }) => [
              (record.state == 1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_1))
                : (_openBlock(), _createElementBlock("span", _hoisted_2)),
              _createElementVNode("span", null, _toDisplayString(record.state == 1 ? "已生成" : "生成中"), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_a_table_column, {
            title: "操作",
            width: 80,
            align: "center"
          }, {
            cell: _withCtx(({ record }) => [
              _withDirectives(_createVNode(_component_a_button, {
                type: "text",
                size: "small",
                onClick: ($event: any) => (download(record.url))
              }, {
                default: _withCtx(() => _cache[1] || (_cache[1] = [
                  _createTextVNode(" 下载 ")
                ])),
                _: 2
              }, 1032, ["onClick"]), [
                [_vShow, record.state == 1]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["loading", "data"])
    ]),
    _: 1
  }))
}
}

})